import { filter, remplazarPorTildeASinTilde } from "../../helpers/Buscador"
import { fetchConToken } from "../../helpers/fetch"
import { handleErrorApi } from "../../helpers/randoms"
import FormulariosMiOspedycService from "../../services/FormulariosMiOspedycService"
import { types } from "../../types/types"
import { startAlerta } from "../ui/alertas"
import { finishSpinner, startSpinner } from "../ui/spinner"

const baseUrl = process.env.REACT_APP_API_URL;

export const getFormularios = (textoBuscado = "") => async (dispatch) => {
    dispatch({ type: types.get_formularios_mi_ospedyc })
    try {
        const response = await FormulariosMiOspedycService.getFormularios()
        const body = await response.json();
        let resultados = body;
        if (response.ok) {
            if (textoBuscado !== "") {
                resultados = resultados.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(textoBuscado)))
            }
            dispatch({
                type: types.get_formularios_mi_ospedyc_success,
                payload: resultados
            })
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.get_formularios_mi_ospedyc_failure })

        handleErrorApi(dispatch, error, "Error al traer los formularios, Intente nuevamente")
    }
}

export const getFormulariosPorCategoria = () => async (dispatch) => {
    dispatch({ type: types.get_formulariosporcategoria_mi_ospedyc })
    try {
        const response = await FormulariosMiOspedycService.getFormulariosPorCategoria()
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.get_formulariosporcategoria_mi_ospedyc_success,
                payload: body
            })
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.get_formulariosporcategoria_mi_ospedyc_failure })

        handleErrorApi(dispatch, error, "Error al traer los formularios, Intente nuevamente")
    }
}


export const guardarFormulario = (id = null, data, handleAfter) => async (dispatch) => {
    dispatch(startSpinner())
    try {
        const { idCategoriaFormularios, descripcion, archivo } = data;

        let resultado;
        if (id !== null) {
            resultado = await FormulariosMiOspedycService.actualizarFormulario(id, {
                idCategoriaFormularios,
                descripcion
            })
        } else {
            resultado = await FormulariosMiOspedycService.crearFormularioMiOspedyc({
                idCategoriaFormularios,
                descripcion
            })
        }
        const body = await resultado.json();
        if (resultado.ok) {
            if (archivo) {
                const bodyFormData = new FormData();
                bodyFormData.append("iFormFileArchivo", archivo)

                const token = localStorage.getItem("token") || sessionStorage.getItem("token") || "";
                let httpHeaders = {
                    Authorization: `Bearer ${token}`,
                };

                const responseARCHIVO = await fetch(
                    `${baseUrl}/MiOspedyc/FormulariosMiOspedyc/CargarArchivo/${id || body.idFormulario}`,
                    {
                        method: "POST",
                        body: bodyFormData,
                        headers: httpHeaders,
                    }
                );

                const bodyArchivo = await responseARCHIVO.json();

                if (responseARCHIVO.ok) {
                    dispatch(getFormularios())
                    dispatch(finishSpinner())
                    handleAfter()
                } else {
                    throw bodyArchivo
                }
            }
        } else {
            throw body
        }

    } catch (error) {
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al guardar el archivo", "Ha ocurrido un error.Intente nuevamente")
    }
}

export const eliminarFormulario = (id) => async (dispatch) => {
    try {
        dispatch(startSpinner())

        const response = await fetchConToken(`MiOspedyc/FormulariosMiOspedyc/${id}`, {}, "DELETE")
        const body = response.json();

        if (response.ok) {
            dispatch(startAlerta("Formulario Eliminado con exito", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner())
            dispatch(getFormularios())
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al borrar el formulario", "Intente nuevamente")
    }
}